export default (nOfQ: number, isTeacherMode = false): number => {
  const teacherModeExtraTimePerQuestion = isTeacherMode ? 0 : 0.2;
  const mins = Math.ceil(nOfQ * (0.5 + teacherModeExtraTimePerQuestion));
  return mins;
};
